export default __webpack_public_path__ + "static/vasebg-e8073f51e8dcb857d7896533e3be9468.png";